import { type MaybeRef, toValue } from 'vue';

import { getStacklets } from '@/entities/stacklet';
import type { RequestMeta } from '@/shared/api';

import {
  getDatabase,
  getDatabaseBackups,
  getDatabaseFirewallRules,
  getDatabases,
  getDatabaseSnapshot,
  getDatabaseSnapshots,
  getDataForCreateDatabase,
} from './api';
import { databaseKeys } from './keys';

export const databaseQueryOptions = (databaseUuid: MaybeRef<string>) => ({
  queryKey: databaseKeys.database(databaseUuid),
  queryFn: () => getDatabase(toValue(databaseUuid)).then((data) => data.database),
});

export const databaseTaskQueryOptions = (databaseUuid: MaybeRef<string>) => ({
  queryKey: databaseKeys.databaseTask(databaseUuid),
  queryFn: () => getDatabase(toValue(databaseUuid)).then((data) => data.database),
});

export const databasesQueryOptions = (params: MaybeRef<RequestMeta>) => ({
  queryKey: databaseKeys.databases(params),
  queryFn: () => getDatabases(toValue(params)),
});

export const databaseSnapshotsQueryOptions = (databaseUuid: MaybeRef<string>) => ({
  queryKey: databaseKeys.databaseSnapshots(databaseUuid),
  queryFn: () => getDatabaseSnapshots(toValue(databaseUuid)).then((data) => data.snapshots),
});

export const databaseSnapshotTaskQueryOptions = (
  databaseUuid: MaybeRef<string>,
  snapshotId: MaybeRef<number>,
) => ({
  queryKey: databaseKeys.databaseSnapshotTask(snapshotId),
  queryFn: () =>
    getDatabaseSnapshot({
      database_uuid: toValue(databaseUuid),
      snapshot_id: toValue(snapshotId),
    }).then((data) => data.snapshot),
});

export const databaseBackupsQueryOptions = (databaseUuid: MaybeRef<string>) => ({
  queryKey: databaseKeys.databaseBackups(databaseUuid),
  queryFn: () => getDatabaseBackups(toValue(databaseUuid)).then((data) => data.backups),
});

export const databaseFirewallRulesQueryOptions = (databaseUuid: MaybeRef<string>) => ({
  queryKey: databaseKeys.databaseFirewallRules(databaseUuid),
  queryFn: () => getDatabaseFirewallRules(toValue(databaseUuid)).then((data) => data.rules),
});

export const databaseSizesQueryOptions = () => ({
  queryKey: databaseKeys.databaseSizes(),
  queryFn: () => getDataForCreateDatabase().then((data) => data.sizes),
});

export const databaseDataForCreateQueryOptions = () => ({
  queryKey: databaseKeys.databaseDataForCreate(),
  queryFn: () => getDataForCreateDatabase().then((data) => data),
});

export const databaseFirewallStackletsQueryOptions = (
  databaseUuid: MaybeRef<string>,
  query: MaybeRef<string>,
) => ({
  queryKey: databaseKeys.databaseFirewallStacklets(databaseUuid, query),
  queryFn: () => getStacklets({ query: toValue(query) }),
});
